import React from 'react';

import { ordersService } from './orders-service';
import { dateService } from '../../../services/date';

import Icon from '../../ui/icon';
import Product from './product';

const EditSubcard = ({ data }) => {
  const formattedProduct = {
    name: data.product_clicked_name,
    brand: data.product_clicked_brand,
    image_url: data.product_clicked_image_url,
    store_page_url: data.product_clicked_store_page_url,
  };

  const youtubeLogo =
    data.attributed_edit_url && data.attributed_edit_url.includes('youtube.co') ? (
      <Icon iconName="youtubeLogo" size={23} />
    ) : null;

  return (
    <div className="edit-subcard">
      <div className="shoplink-click">
        <span>ShopLink Click</span>
        <span className="datetime">{ordersService.format(data.datetime_attributed_click)}</span>
      </div>

      <a href={data.attributed_edit_url} target="_blank" rel="noopener noreferrer">
        <div className="content">
          <div className="logo-name">
            {youtubeLogo}
            <span className="edit-name">{data.attributed_edit_name}</span>
          </div>
          <div className="edit-date">
            {dateService.formatDisplayDate(data.datetime_attributed_edit_created)}
          </div>
        </div>
      </a>
      <Product data={formattedProduct} />
    </div>
  );
};

export default EditSubcard;
